// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.joblist-container .badge-custom {
  background-color: #E7F6EA !important;
  color: #0BA02C !important;
}
.joblist-container .border-cobaltblue {
  border: 1px solid #0A4FAE;
  box-shadow: 0 0 1px 0 #0A4FAE;
}
.joblist-container .pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/HomeContent/JobList/JobList.scss"],"names":[],"mappings":"AACE;EACE,oCAAA;EACA,yBAAA;AAAJ;AAGE;EACE,yBAAA;EACA,6BAAA;AADJ;AAIE;EACE,eAAA;AAFJ","sourcesContent":[".joblist-container {\n  .badge-custom {\n    background-color: #E7F6EA !important;\n    color: #0BA02C !important;\n  }\n  \n  .border-cobaltblue {\n    border: 1px solid #0A4FAE;\n    box-shadow: 0 0 1px 0 #0A4FAE;\n  }\n  \n  .pointer {\n    cursor: pointer;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
